import React, { Component } from "react";
import PropTypes from "prop-types";

import { Card, Form, Button, Input, message, Select } from "antd";
import { connect } from "react-redux";
import storageUtils from "../../utils/storageUtils";
import {
  req_add_smscontent,
  req_edit_smscontent,
  req_single_people,
} from "../../api";

const Item = Form.Item;

class UniversalNewsEditModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    news: PropTypes.object,
  };

  state = {
    isUpdate: false,
    isInsert: false,
    nowWeek: 0,
    selectedWeek: 1,
    selectedDepartCode: "",
    selectedDepartName: "",
    departs: [
      { label: "董事會", value: "138" },
      { label: "教務處註冊組", value: "68" },
      { label: "教務處課務組", value: "67" },
      { label: "教務處教學發展中心", value: "217" },
      { label: "學務處生活輔導組", value: "72" },
      { label: "學務處課外活動組", value: "218" },
      { label: "學務處衛生保健組", value: "74" },
      { label: "學務處諮商輔導中心", value: "219" },
      { label: "總務處事務組", value: "76" },
      { label: "總務處保管組", value: "77" },
      { label: "總務處營繕組", value: "81" },
      { label: "總務處出納組", value: "82" },
      { label: "總務處文書組", value: "83" },
      { label: "總務處環安組", value: "84" },
      { label: "研發處國際暨兩岸事務中心", value: "220" },
      { label: "研發處學術暨產學合作中心", value: "210" },
      { label: "研發處職涯發展中心", value: "211" },
      { label: "研發處國際專修部", value: "240" },
      { label: "進修推廣中心教務組", value: "235" },
      { label: "進修推廣中心綜合業務組", value: "236" },
      { label: "通識教育中心", value: "1" },
      { label: "圖資中心行政及諮詢服務組", value: "225" },
      { label: "圖資中心網路作業組", value: "226" },
      { label: "圖資中心校務資訊組", value: "227" },
      { label: "圖資中心讀者服務組", value: "223" },
      { label: "圖資中心採編組", value: "224" },
      { label: "人事室人力資源組", value: "102" },
      { label: "人事室人事服務組", value: "103" },
      { label: "會計室", value: "38" },
      { label: "會計室歲計組", value: "104" },
      { label: "會計室審核組", value: "105" },
      { label: "秘書室", value: "208" },
      { label: "秘書室行政組", value: "106" },
      { label: "秘書室公共關係組", value: "107" },
      { label: "秘書室校友服務組", value: "208" },
      { label: "秘書室校務稽核組", value: "237" },
      { label: "體育室", value: "46" },
      { label: "招生策進中心宣傳組", value: "233" },
      { label: "招生策進中心試務組", value: "234" },
      { label: "校務發展中心計畫管理組", value: "232" },
      { label: "校務發展中心校務研究組", value: "230" },
      { label: "師資培育中心", value: "22" },
      { label: "生活科技學院", value: "60" },
      { label: "服飾設計管理系", value: "3" },
      { label: "美容造型設計系", value: "4" },
      { label: "幼兒保育系", value: "5" },
      { label: "餐飲系", value: "165" },
      { label: "生活服務產業系", value: "178" },
      { label: "運動休閒與健康管理系", value: "199" },
      { label: "管理學院", value: "59" },
      { label: "國際企業經營系", value: "7" },
      { label: "財務金融系", value: "8" },
      { label: "資訊管理系", value: "24" },
      { label: "企業管理系", value: "161" },
      { label: "連鎖加盟經營管理進修學士學位學程", value: "238" },
      { label: "設計學院", value: "62" },
      { label: "室內設計系", value: "11" },
      { label: "視覺傳達設計系 ", value: "17" },
      { label: "商品設計系", value: "18" },
      { label: "多媒體動畫系", value: "164" },
      { label: "時尚設計系", value: "159" },
      { label: "藝術學院", value: "63" },
      { label: "美術系", value: "19" },
      { label: "音樂系", value: "20" },
      { label: "舞蹈系", value: "21" },
      { label: "流行音樂系", value: "213" },
      { label: "漫畫系", value: "212" },
      { label: "旅遊學院", value: "193" },
      { label: "應用英語系", value: "187" },
      { label: "旅館管理系", value: "196" },
      { label: "餐旅管理進修學士學位學程", value: "239" },
      { label: "養生休閒管理系", value: "214" },
      { label: "漢家幼兒園 ", value: "15" },
      { label: "全球刺繡研究發展中心", value: "117" },
      { label: "語文訓練中心", value: "57" },
      { label: "文化創意設計研發中心", value: "166" },
    ],
    weeks: [
      { label: "第01週", value: "1" },
      { label: "第02週", value: "2" },
      { label: "第03週", value: "3" },
      { label: "第04週", value: "4" },
      { label: "第05週", value: "5" },
      { label: "第06週", value: "6" },
      { label: "第07週", value: "7" },
      { label: "第08週", value: "8" },
      { label: "第09週", value: "9" },
      { label: "第10週", value: "10" },
      { label: "第11週", value: "11" },
      { label: "第12週", value: "12" },
      { label: "第13週", value: "13" },
      { label: "第14週", value: "14" },
      { label: "第15週", value: "15" },
      { label: "第16週", value: "16" },
      { label: "第17週", value: "17" },
      { label: "第18週", value: "18" },
      { label: "第19週", value: "19" },
      { label: "第20週", value: "20" },
      { label: "第21週", value: "21" },
      { label: "第22週", value: "22" },
      { label: "第23週", value: "23" },
      { label: "第24週", value: "24" },
      { label: "第25週", value: "25" },
      { label: "第26週", value: "26" },
      { label: "第27週", value: "27" },
      { label: "第28週", value: "28" },
      { label: "第29週", value: "29" },
      { label: "第30週", value: "30" },
      { label: "第31週", value: "31" },
      { label: "第32週", value: "32" },
      { label: "第33週", value: "33" },
      { label: "第34週", value: "34" },
      { label: "第35週", value: "35" },
      { label: "第36週", value: "36" },
      { label: "第37週", value: "37" },
      { label: "第38週", value: "38" },
      { label: "第39週", value: "39" },
      { label: "第40週", value: "40" },
      { label: "第41週", value: "41" },
      { label: "第42週", value: "42" },
      { label: "第43週", value: "43" },
      { label: "第44週", value: "44" },
      { label: "第45週", value: "45" },
      { label: "第46週", value: "46" },
      { label: "第47週", value: "47" },
      { label: "第48週", value: "48" },
      { label: "第49週", value: "49" },
      { label: "第50週", value: "50" },
      { label: "第51週", value: "51" },
      { label: "第52週", value: "52" },
    ],
    selectedCategory: "一般公告",
    category: [
      { label: "一般公告", value: "一般公告" },
      { label: "媒體報導", value: "媒體報導" },
      { label: "各式展演", value: "各式展演" },
      { label: "活動報名", value: "活動報名" },
      { label: "演講研討會", value: "演講研討會" },
      { label: "多元競賽", value: "多元競賽" },
      { label: "競賽獲獎", value: "競賽獲獎" },
      { label: "考試資訊", value: "考試資訊" },
      { label: "招生公告", value: "招生公告" },
      { label: "媒體報導", value: "媒體報導" },
      { label: "獎助學金", value: "獎助學金" },
      { label: "實習工讀", value: "實習工讀" },
      { label: "職缺公告", value: "職缺公告" },
      { label: "榜單公告", value: "榜單公告" },
      { label: "捐贈興學", value: "捐贈興學" },
      { label: "徵稿徵圖", value: "徵稿徵圖" },
      { label: "抽獎活動", value: "抽獎活動" },
      { label: "中獎通知", value: "中獎通知" },
      { label: "師生優惠", value: "師生優惠" },
    ],
    item: {
      Uid: "",
      DepartmentCode: "",
      DepartmentTwName: "",
      DataCategory: "一般公告",
      DataContent: "",
      DataUrl: "",
      SendMailWeekNum: "",
      RecordCreatorCode: "",
      RecordCreatorName: "",
    },
    user: {},
  };

  UNSAFE_componentWillMount() {
    this.init();
  }

  componentDidMount() {}

  // 遠端數據處理 //////////////////////////////////////////////

  api_user_data = async () => {
    const user = await req_single_people(
      storageUtils.getUser().userCode,
      storageUtils.getUser().token
    );
    if (user) {
      this.setState({ user });
    }
  };

  api_modify_item = async (item) => {
    const { isUpdate } = this.state;
    // console.log(item);
    if (isUpdate) {
      // const { uid } = this.props.bulletinBoard;
      // item.uid = uid;
      // console.log(applycase)
      const result = await req_edit_smscontent(
        item,
        storageUtils.getUser().token
      );
      if (result.status === "success") {
        // console.log(result)
        message.success(result.message);
      } else {
        message.error(result.message);
      }
    } else {
      const result = await req_add_smscontent(
        item,
        storageUtils.getUser().token
      );
      if (result.status === "success") {
        message.success(result.message);
      } else {
        message.error(result.message);
      }
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  getYearWeek = (year, month, day) => {
    var nowDay = new Date(year, month - 1, day);
    var firstYearDay = new Date(year, 0, 1);
    var nowYearDay = Math.ceil((nowDay - firstYearDay) / (24 * 60 * 60 * 1000));
    return Math.ceil((nowYearDay + (firstYearDay.getDay() + 1 - 1)) / 7);
  };

  init = () => {
    // console.log("init");
    const { SendMailWeekNum, DataCategory, DepartmentCode, DepartmentTwName } =
      this.props.news;
    const { weeks } = this.state;
    const currentdate = new Date();
    const nowWeek =
      this.getYearWeek(
        currentdate.getFullYear(),
        currentdate.getMonth() + 1,
        currentdate.getDate()
      ) + 1;
    var weekSelect = [];
    weeks.forEach((element) => {
      if (element.value > nowWeek) {
        weekSelect.push(element);
      }
    });
    this.setState({
      nowWeek,
      weeks: weekSelect,
      selectedWeek: SendMailWeekNum,
      selectedCategory: DataCategory,
      selectedDepartCode: DepartmentCode,
      selectedDepartName: DepartmentTwName,
    });

    if (this.props.news) {
      const item = this.props.news;
      this.setState({ item, isUpdate: true });
    }
    this.api_user_data();
  };

  // 操作互動處理 //////////////////////////////////////////////
  handleWeekChange = (value) => {
    //console.log(value);
    this.setState({ selectedWeek: value });
  };

  handleCategoryChange = (value) => {
    //console.log(value);
    this.setState({ selectedCategory: value });
  };

  onFinish = (values) => {
    // console.log("Success:", values);
    const { DataContent, DataUrl } = values;
    const { userCode, userName } = storageUtils.getUser();
    const {
      selectedWeek,
      selectedCategory,
      selectedDepartCode,
      selectedDepartName,
    } = this.state;
    const news = {
      Uid: this.state.item.Uid,
      DepartmentCode: selectedDepartCode,
      DepartmentTwName: selectedDepartName,
      DataCategory: selectedCategory,
      DataContent: DataContent,
      DataUrl: DataUrl,
      SendMailWeekNum: selectedWeek,
      RecordCreatorCode: userCode,
      RecordCreatorName: userName,
      condition: "ALL",
    };
    //console.log(news);
    this.api_modify_item(news);
  };

  ///////////////////////////////////////////////////////////

  render() {
    const { isUpdate, weeks, selectedWeek, category, departs } = this.state;
    const { DataContent, DataCategory, DataUrl, DepartmentCode } =
      this.state.item;
    return (
      <Card>
        <Form onFinish={this.onFinish}>
          <Item label="寄發單位">
            <Select
              defaultValue={DepartmentCode}
              onChange={this.handleDepartmentChange}
              style={{
                width: 200,
              }}
              options={departs}
              disabled={true}
            />
          </Item>
          <Item label="寄發週別">
            <Select
              defaultValue={"第" + selectedWeek + "週"}
              onChange={this.handleWeekChange}
              style={{
                width: 200,
              }}
              options={weeks}
            />
          </Item>
          <Item label="內容分類">
            <Select
              defaultValue={DataCategory}
              onChange={this.handleCategoryChange}
              style={{
                width: 200,
              }}
              options={category}
            />
          </Item>
          <Item
            label="主旨內容"
            name="DataContent"
            initialValue={DataContent}
            rules={[
              { required: true, whitespace: true, message: "必須填寫內容" },
            ]}
          >
            <Input placeholder="輸入主旨內容" />
          </Item>
          <Item
            label="外部網址"
            name="DataUrl"
            initialValue={DataUrl}
            rules={[
              { whitespace: true },
              {
                type: "url",
                message: "請輸入正確的外部網址",
              },
            ]}
          >
            <Input placeholder="相關內容網址(非必填)" />
          </Item>
          <Item>
            <Button type="primary" htmlType="submit" className="wave" block>
              {isUpdate ? "修改" : "送出"}
            </Button>
          </Item>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(UniversalNewsEditModal);
